<template>
  <div>
    <h1 :class="$style.title">
      {{notFoundMessage}}
      <template v-if="resource">
        {{ resource }}
      </template>
    </h1>
  </div>
</template>

<script>
  import texts from '../constants/display-texts.js'

  export default {
    page: {
      title: '404',
      meta: [{ name: 'description', content: '404' }],
  },
    data() {
      return {
        notFoundMessage: texts.NotFoundMessage,
      };
    },
    components: { },
    props: {
      resource: { type: String, default: '' },
    },
  }
</script>

<style lang="scss" module>
  .title {
    text-align: center;
  }
</style>
